export default function ({commit}, value) {
    commit('page', value);
}